import { connect } from 'react-redux';

// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as actions from 'common/actions';
import FlashMessages from 'common/components/FlashMessages';

const mapStateToProps = state => ({
  flashMessages: state.flashMessages,
});

const mapDispatchToProps = dispatch => ({
  makeClearForId: id => () => {
    dispatch(actions.clearFlashMessage(id));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlashMessages);
